<header class="main-header main-header--one  clearfix">
  <div style="height: 30px;background-color: white;text-align: end;margin-top: 7px;"
    class="border-bottom header-top-info">
    <span style="margin-right: 20px;margin-left: 20px;font-weight: bold;"><i class="fa fa-envelope ml-2 mr-2 email-icon"
        [ngClass]="lang==='ar' ? 'float-left' : ''" style="font-size: 20px;"></i> <a style="color: #1a1a1a;"
        href="mailto:information@tableegh.ae">information@tableegh.ae</a></span><span
      style="margin-right: 20px;margin-left: 20px;font-weight: bold;"><i class="fa fa-phone ml-2 mr-4"
        style="font-size: 20px;"></i> <a style="color: #1a1a1a;" href="tel:0097143949444" class="text-dir-ltr">+971 4
        3949444</a></span>
  </div>

  <div class="main-header-one__bottom">
    <div class="auto-container">
      <div class="main-header-one__bottom-inner clearfix">
        <nav class="main-menu main-menu--1">
          <!-- menu -->
          <div class="main-menu__inner">
            <div class="left">
              <div class="logo-box1" style="width: 0px;">
                <div class="logo-box1_bg">
                </div>
              </div>
            </div>
            <div class="left main-logo-image">
              <div class="logo-box1">
                <div class="logo-box1_bg">
                </div>
                <a routerLink="/">
                  <img src="assets/images/logo-mini.png" alt="img" class="public-main-logo-img">
                </a>
              </div>
            </div>
            <a href="javascript:void(0)" class="mobile-nav__toggler" (click)="toggleNav()"><i
                class="fa fa-bars"></i></a>
            <div class="middle">
              <ul class="main-menu__list">

                <li [ngClass]="item.child === true ? 'dropdown' : ''" *ngFor="let item of navigationArray"
                  class="ml-4 mr-4">
                  <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText | translate}}<span
                      class="nav_arrow"></span></a>
                  <a routerLink="{{item.link}}" *ngIf="!item.child && item.id !==3 && item.id !==4">{{item.linkText|
                    translate}}</a>
                  <a (click)="goToDiv('about-us-section')" href="javascript:void(0)"
                    *ngIf="!item.child && item.id ===3">{{item.linkText| translate}}</a>
                  <a (click)="goToDiv('contact-us-section')" href="javascript:void(0)"
                    *ngIf="!item.child && item.id ===4">{{item.linkText| translate}}</a>

                  <ul class="sub-menu" *ngIf="item.child">
                    <li [ngClass]="item.child === true ? 'dropdown' : ''" *ngFor="let item of item.submenu">
                      <a href="javascript:void(0)" *ngIf="item.child">{{item.linkText| translate}}<span
                          class="nav_arrow"></span></a>
                      <a routerLink="{{item.link}}" *ngIf="!item.child" class="font-size-23">{{item.linkText|
                        translate}}</a>
                      <ul class="sub-menu" *ngIf="item.child">
                        <li *ngFor="let item of item.submenu">
                          <a routerLink="{{item.link}}">{{item.linkText| translate}}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>


              </ul>
            </div>
            <div class="right">
              <div class="main-menu__right">

                <a *ngIf="!userProfile || userProfile === null || userProfile.isLoggedIn !== true"
                  routerLink="/account/login" class="btn btn-primary fw-bold" style="width: 125px;">{{'login' |
                  translate}}</a>

                <ul class="main-menu__list pl-3 pr-3">

                  <li class="dropdown">
                    <a href="javascript:void(0)">{{(lang==='ar'?'arabicLanguage' : 'englishLanguage') | translate}}<span
                        class="nav_arrow"></span></a>
                    <ul class="sub-menu">
                      <li class="dropdown">
                        <a href="javascript:(void)" (click)="changeLanguage()"
                          class="font-size-23">{{(lang==='ar'?'englishLanguage' :
                          'arabicLanguage') | translate}}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown mr-4 ml-4"
                    *ngIf="userProfile && userProfile !== null && userProfile.isLoggedIn === true">
                    <a href="javascript:void(0)">{{'profile' | translate}}<span class="nav_arrow"></span></a>
                    <ul class="sub-menu">
                      <li class="dropdown">
                        <a routerLink="/user/userDetails/{{userProfile.id}}" class="font-size-23">{{'myProfile' |
                          translate}}</a>
                      </li>
                      <li class="dropdown">
                        <a routerLink="/order/orders" class="font-size-23">{{'myOrders' | translate}}</a>
                      </li>
                      <li class="dropdown">
                        <a routerLink="/order/ordersServices" class="font-size-23">{{'myServices' | translate}}</a>
                      </li>
                      <li class="dropdown">
                        <a href="javascript:(void)" (click)="logout()" class="font-size-23">{{'logout' |
                          translate}}</a>
                      </li>
                    </ul>
                  </li>
                </ul>

                <!-- <div class="phone_number">
                  <div class="icon">
                    <span class="icon-agenda"></span>
                  </div>
                  <div class="number text-dir-ltr">
                    <p>{{'contactUs' | translate}}</p>
                    <a href="tel:0097143949444">+971 4 3949444</a>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <!-- menu -->
        </nav>
      </div>
    </div>
  </div>
</header>


<!-- Mobilemenu -->
<div class="mobile-nav__wrapper" [ngClass]="navmethod ? 'expanded' : ''">
  <div class="mobile-nav__overlay mobile-nav__toggler" (click)="toggleNav()"></div>
  <!-- /.mobile-nav__overlay -->
  <div class="mobile-nav__content">
    <span class="mobile-nav__close mobile-nav__toggler" id="closeIcon" (click)="toggleNav()"><i
        class="fa fa-times"></i></span>
    <app-mobile-menu></app-mobile-menu>
  </div>
  <!-- /.mobile-nav__content -->
</div>
<!-- Mobilemenu -->
